import { createAction } from '@mews-framework/redux';
import { LogData } from '../../../services';

export const WARNING_LOGGED = '@@sentry/WARNING_LOGGED';

export const logSentryWarning = ({ error, extra = {} }: LogData) => createAction(WARNING_LOGGED, { error, extra });

export type LogSentryWarningAction = ReturnType<typeof logSentryWarning>;
